<template>
   <svg class="stroke-current" name="trash" viewBox="0 0 16 17" aria-hidden="true" focusable="false">
      <path d="M2 4.5H3.33333H14" stroke-linecap="square" stroke-linejoin="round" />
      <path
         d="M5.33325 4.49992V3.16659C5.33325 2.81296 5.47373 2.47382 5.72378 2.22378C5.97382 1.97373 6.31296 1.83325 6.66659 1.83325H9.33325C9.68687 1.83325 10.026 1.97373 10.2761 2.22378C10.5261 2.47382 10.6666 2.81296 10.6666 3.16659V4.49992M12.6666 4.49992V13.8333C12.6666 14.1869 12.5261 14.526 12.2761 14.7761C12.026 15.0261 11.6869 15.1666 11.3333 15.1666H4.66659C4.31296 15.1666 3.97382 15.0261 3.72378 14.7761C3.47373 14.526 3.33325 14.1869 3.33325 13.8333V4.49992H12.6666Z"
         stroke-linecap="square"
         stroke-linejoin="round"
      />
      <path d="M6.66675 7.83325V11.8333" stroke-linecap="square" stroke-linejoin="round" />
      <path d="M9.33325 7.83325V11.8333" stroke-linecap="square" stroke-linejoin="round" />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
